var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape-1",
    fill: "#656565",
    d: "M1210.13 173.298a.533.533 0 00-.72.188c-1.24 2.086-3.55 3.486-6.2 3.486-3.95 0-7.16-3.128-7.16-6.972 0-3.845 3.21-6.973 7.16-6.973 2.65 0 4.96 1.402 6.2 3.487.14.245.47.329.72.187a.504.504 0 00.19-.702c-1.42-2.399-4.08-3.999-7.11-3.999-4.54 0-8.21 3.578-8.21 8 0 4.421 3.67 8 8.21 8 3.03 0 5.69-1.602 7.11-4a.504.504 0 00-.19-.702zm-.12-3.812v-.809c0-.415.49-.659.84-.42l1.92 1.323a.51.51 0 010 .84l-1.92 1.322c-.35.238-.84-.001-.84-.42v-.809h-9.24a.523.523 0 01-.53-.513c0-.28.23-.508.53-.514h9.24z",
    transform: "translate(-1195 -161)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.8f964dc4123b5ee3be7bcb684decf8e6.svg";
export { ForwardRef as ReactComponent };